import { createContext, useContext } from "react";

// Persistent routes and subject tabs stay mounted while hidden. Previews read
// this to drop (and tell the backend to stop) renders nobody can see; they
// request again, usually from cache, once their page is shown again.
const PreviewActivityContext = createContext(true);

export const PreviewActivityProvider = PreviewActivityContext.Provider;
export const usePreviewActivity = () => useContext(PreviewActivityContext);
